import { Box, Typography } from '@mui/material';

export const NotFoundPage = () => {
  return (
    <Box sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" color="text.secondary">
        Page Not Found
      </Typography>
    </Box>
  );
};
